import UploadBase from './UploadBase';
import {uploadconfig} from '../config/uploadconfig';

export {UploadBase};


export const findUpload = (service:string) => {
  const uploads:any = uploadconfig;
  return uploads[service];
}

export const getUpload = (service:string) => {
  const uploads:any = uploadconfig;
  return uploads[service];
}
